// Sync i18n-js with Rails: <html lang>, meta application-locale, then Finnish (production default).
(function () {
  'use strict';

  function pickSupportedLocale(code) {
    var t = window.I18n && window.I18n.translations;
    if (!t) return 'fi';
    var c = (code || '').toString().split('-')[0].toLowerCase();
    if (c && t[c]) return c;
    if (t.fi) return 'fi';
    if (t.en) return 'en';
    var keys = Object.keys(t);
    return keys.length ? keys[0] : 'fi';
  }

  function syncI18nLocaleFromDocument() {
    if (typeof document === 'undefined' || !document.documentElement) return;
    if (typeof window.I18n === 'undefined') return;

    var meta = document.querySelector('meta[name="application-locale"]');
    var hint = (meta && meta.getAttribute('content')) ? meta.getAttribute('content').trim() : '';
    var fromHtml = (document.documentElement.getAttribute('lang') || '').trim();
    // Prefer HTML lang; then Rails-injected locale; then fi (production default)
    var raw = fromHtml || hint || 'fi';
    var code = pickSupportedLocale(raw.split('-')[0].toLowerCase());

    // defaultLocale drives missing-key fallbacks: match app (meta) when present, else fi
    window.I18n.defaultLocale = pickSupportedLocale((hint || 'fi').split('-')[0].toLowerCase());
    window.I18n.locale = code;
  }

  /**
   * Resolve a key trying active locale, then defaultLocale, then fi, then en.
   */
  window.i18nTranslateWithFallbacks = function (scope, options) {
    var I18n = window.I18n;
    if (!I18n || !I18n.t) return '';
    options = options || {};
    var prev = I18n.locale;
    var msg = I18n.t(scope, options);
    if (typeof msg === 'string' && msg.indexOf('[missing "') !== 0) {
      return msg;
    }

    var order = [];
    if (I18n.defaultLocale) order.push(I18n.defaultLocale);
    if (order.indexOf('fi') < 0) order.push('fi');
    if (order.indexOf('en') < 0) order.push('en');

    for (var i = 0; i < order.length; i++) {
      var loc = order[i];
      if (!I18n.translations || !I18n.translations[loc]) continue;
      I18n.locale = loc;
      msg = I18n.t(scope, options);
      I18n.locale = prev;
      if (typeof msg === 'string' && msg.indexOf('[missing "') !== 0) {
        return msg;
      }
    }
    I18n.locale = prev;
    return msg;
  };

  window.i18nPickSupportedLocale = pickSupportedLocale;

  syncI18nLocaleFromDocument();

  if (typeof document !== 'undefined') {
    document.addEventListener('turbolinks:load', syncI18nLocaleFromDocument);
    document.addEventListener('turbo:load', syncI18nLocaleFromDocument);
  }

  window.syncI18nLocaleFromDocument = syncI18nLocaleFromDocument;
})();
